import React from "react";
import { UserContext } from "../Context/UserContext";
import { Table, Button, Input } from 'antd';
import { useContext, useEffect } from "react";
import { useState } from "react";
import axios from "axios";

const DataMovies = () => {

    const {functions, dataMove, setDataMove, fetchStatus, setFetchStatus}= useContext (UserContext)
    
    const {getMovies, handleEdit, handleDelete} = functions

        
    useEffect (() => {
    
    
        if (fetchStatus) {
        getMovies()
        setFetchStatus(false)}},[getMovies, fetchStatus, setFetchStatus]
        
    )


    const columns = [
        {
          title: 'Title',
          dataIndex: 'title',
          key: 'title',
        },
        
        {
          title: 'Preview',
          dataIndex: 'image_url',
          key: 'image_url',
          render: (e) => { return (
          
            <img src={e} style={{objectFit: "cover"}} alt="games" width={75} height={75} />
          )
          }
        }, 
        {
          title: 'Description',
          dataIndex: 'description',
          key: 'description',
        },
        {
          title: 'Year',
          dataIndex: 'year',
          key: 'year',
        },
        {
            title: 'Duration',
            dataIndex: 'duration',
            key: 'duration',
          },
          {
            title: 'Genre',
            dataIndex: 'genre',
            key: 'genre',
          },

          {
            title: 'Rating',
            dataIndex: 'rating',
            key: 'rating',
          },
          {
            title: 'Review',
            dataIndex: 'review',
            key: 'review',
          },

        {
          title: 'Action',
          key: 'action',
          render: (res, index) => (
            <>
            <Button type="primary" style={{backgroundColor:"blueviolet"}} value={res.id} onClick={handleEdit} style={{marginLeft:"10px"}} >Edit</Button>
            <br/>
            <br/>
            <Button type="primary" danger value={res.id} onClick={handleDelete} style={{marginLeft:"10px"}}>Delete</Button>
                
            </>
          ),
        },
      ];
      
      const data = dataMove
     console.log(dataMove)
    
     const [search, setSearch] = useState("")
     const [filter, setFilter] = useState({
       genre: "",
       year: 0,
       rating:0
     })
 
 const handleChange = (e) => {
  
   let value = e.target.value
  
  setSearch(value)
 }
 
 const handleChangeFilter = (e) => {
   let value = e.target.value
   let typeOfName = e.target.name
 
   setFilter({...filter, [typeOfName] : value})
 }
 
 const handleSearch = async (e) => {
 e.preventDefault()
 
 let result = await axios.get('https://backendexample.sanbersy.com/api/data-movie')
 
 let dataSearch = result.data
 
 let resultSearch = dataSearch.filter((e) => {
   return (
     Object.values(e).join(" ").toLowerCase().includes(search.toLowerCase())
   )
 
 }
 
 )
 setSearch("")
 setDataMove([...resultSearch])
 }
 
 const handleFilter = async (e) => {
   e.preventDefault()
 
 let result = await axios.get('https://backendexample.sanbersy.com/api/data-movie')
 
 let dataSearch = result.data
 
 let resultFilter = dataSearch.filter((e) => {
 return e.genre.toLowerCase() === filter.genre.toLowerCase() || e.year === filter.year || e.rating === filter.rating
 })
 
 setFilter ({
       genre: "",
       year: 0,
       rating:0
 })
 setDataMove([...resultFilter])
 
 }
      
return (
    <>
    <div>
    <h1 style={{color: "white", fontSize: "35px", marginTop:"10px", textAlign:"center", fontWeight:"bold", marginTop: "80px"}}>Data Movies</h1>
    <form style={{display:"flex", flexDirection:"row"}} onSubmit={handleFilter}>
     <Input name="genre" onChange={handleChangeFilter} style={{marginRight: "20px", width: "280%"}} type="text" placeholder="Genre"/>
     <Input name="year" onChange={handleChangeFilter} style={{marginRight: "20px", width: "280%"}} type="text" placeholder="Year" />
     <Input name="rating"onChange={handleChangeFilter}  style={{width: "280%", marginRight: "10px"}} type="text"placeholder="Rating" />
     <Input style={{width: "100%", height:"50%", fontSize: "10px"}} type="submit" value="Filter"/>
    </form>
   <form style={{display:"flex", flexDirection:"row", marginTop: "-20px"}} onSubmit={handleSearch}>
     <Input onChange={handleChange} style={{width: "300%"}} type="text" placeholder="Search Movie's Title..." />
     <Input  style={{width: "100%", height:"50%", fontSize: "10px"}}type="submit" value="Search"/>
    
    </form>
    <Button type="primary" onClick ={()=>{
     setFetchStatus(true)
   }}>Reset Filter</Button>
   <h1> 
     <br/>
<Table className="table-tugas15" columns={columns} dataSource={data} scroll={{ x: 750, y: 3000 }} />
</h1>
</div>
</>


    )}

export default DataMovies